import React, { useEffect } from 'react';
import './MaintenanceFeeAlert.css';

/**
 * MaintenanceFeeAlert - Modal popup for maintenance fee payment reminder
 * Displays bilingual (English and Hindi) payment reminder with action buttons
 * 
 * @param {Object} props
 * @param {string} props.paymentLink - URL to payment portal
 * @param {string} props.messageEnglish - English message text
 * @param {string} props.messageHindi - Hindi message text
 * @param {boolean} props.forceDisplay - If true, user cannot dismiss the alert
 * @param {boolean} props.isAdmin - If true, admin can always dismiss (even when forced)
 * @param {function} props.onClose - Callback when alert is dismissed
 */
function MaintenanceFeeAlert({ paymentLink, messageEnglish, messageHindi, forceDisplay, isAdmin, onClose }) {
  // Handle ESC key to close alert (only if not forced OR if user is admin)
  useEffect(() => {
    if (forceDisplay && !isAdmin) return; // Don't allow ESC key if forced (unless admin)
    
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    
    // Cleanup event listener on unmount
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose, forceDisplay, isAdmin]);

  const handlePayNow = () => {
    if (!paymentLink || paymentLink.trim() === '') {
      alert('Payment link not configured. Please contact administrator.');
      return;
    }

    const newWindow = window.open(paymentLink, '_blank', 'noopener,noreferrer');
    
    // Check if popup was blocked
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      alert('Popup blocked. Please allow popups for this site or copy the payment link: ' + paymentLink);
    }
  };

  return (
    <div className="alert-overlay" onClick={forceDisplay && !isAdmin ? undefined : onClose}>
      <div className="alert-modal alert-modal-warning" onClick={(e) => e.stopPropagation()}>
        <div className="alert-header alert-header-warning">
          <h2>⚠️ Payment Reminder / भुगतान अनुस्मारक</h2>
          {(!forceDisplay || isAdmin) && (
            <button className="alert-close-btn" onClick={onClose} aria-label="Close">
              ×
            </button>
          )}
        </div>
        
        <div className="alert-content">
          <p className="alert-message-en alert-message-warning">
            {messageEnglish}
          </p>
          
          <p className="alert-message-hi alert-message-warning">
            {messageHindi}
          </p>
        </div>
        
        <div className="alert-actions">
          <button 
            onClick={handlePayNow} 
            className="btn-pay-now btn-warning"
            disabled={!paymentLink || paymentLink.trim() === ''}
          >
            Pay Now / अभी भुगतान करें
          </button>
        </div>
      </div>
    </div>
  );
}

export default MaintenanceFeeAlert;
